import { Input } from 'components/atoms';
import { useFormikField } from 'hooks/useFormikField';
import { useEffect, useState } from 'react';
import { INumberInputProps } from 'types/components/inputs/input.interface';

const NumberInputForm = ({ name, ...props }: INumberInputProps) => {
  const [field, { error, value, status }, { setValue }] = useFormikField<
    number | null
  >(name ?? '');

  const [stringValue, setStringValue] = useState<string | undefined>(
    field.value?.toString()
  );

  useEffect(() => {
    setStringValue(field.value?.toString());
  }, [field.value]);

  return (
    <Input.Number
      displayMode={status?.displayMode}
      isLoading={status?.isLoading}
      {...props}
      onValueChange={(value, name, values) => {
        setStringValue(value ?? undefined);
        setValue(values?.float ?? null);
      }}
      decimalSeparator=','
      groupSeparator={props.groupSeparator ?? ' '}
      value={stringValue}
      error={error}
      disableAbbreviations={true}
    />
  );
};

export default NumberInputForm;
